import { Video } from '@carbon/icons-react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FormControl, MenuItem, Select } from '@mui/material';

import { useMediaDevicesContext } from '../../providers/media-devices-context';

export const CameraSelector = () => {
  const {
    cameras,
    selectedCamera,
    setSelectedCamera,
    isRequestingPermissions,
  } = useMediaDevicesContext();

  return (
    <FormControl fullWidth>
      <Select
        value={selectedCamera}
        onChange={(e) => setSelectedCamera(e.target.value)}
        disabled={isRequestingPermissions}
        startAdornment={<Video size={26} />}
        IconComponent={KeyboardArrowDownIcon}
        variant='filled'
        sx={{
          borderRadius: 1,
          '.MuiSelect-select': {
            fontSize: '0.875rem',
          },
          '& fieldset': {
            border: 'none',
          },
        }}
      >
        {cameras.map((camera) => (
          <MenuItem
            key={camera.deviceId}
            value={camera.deviceId}
            sx={{ fontSize: '0.875rem' }}
          >
            {camera.label || `Camera ${camera.deviceId.substr(0, 5)}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
